import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'

import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'

class HighlightSlider {
  constructor(el) {
    this.el = el

    this.init()
  }

  defineConfig() {
    this.config = {
      modules: [ Navigation, Pagination, Autoplay ],
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: this.el.querySelector('.highlight-gal__pagination'),
        clickable: true
      },
      autoplay: {
        delay: 5000,
      },
    }
  }

  defineSlider() {
    new Swiper(this.el, this.config)
  }

  init() {
    this.defineConfig()
    this.defineSlider()
  }
}

const highlightGalsList = document.querySelectorAll('.highlight-gal')
highlightGalsList.forEach(slider => {
  new HighlightSlider(slider)
})